module.exports = __webpack_public_path__ + "img/logo100.5e6f5b20.png";